export const BUTTON_PATH = 'https://nestbank.pl/';
